import React, { createContext, useContext } from "react";

const ApplyContext = createContext({ openApply: () => {} });

export const useApply = () => useContext(ApplyContext);

export const ApplyProvider = ({ children }) => {
  const openApply = () => {
    const el = document.getElementById("waitlist");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <ApplyContext.Provider value={{ openApply }}>
      {children}
    </ApplyContext.Provider>
  );
};
